<section>
  <router-outlet></router-outlet>
</section>

<div class="d-flex h-100 justify-content-center align-items-center" *ngIf="isPendingLicenseStatus">
  <app-loader></app-loader>
</div>